import { Box, FormControlLabel, Toolbar, useTheme } from '@mui/material'
import { Controller, useForm } from 'react-hook-form'
import { MaterialUISwitch } from '../forms/UserForm'
import { useContext, useEffect } from 'react'
import { ThemeContext } from '../../App'
import UserControls from './UserControls'
import OnlineStatusIndicator from '../online-status-indicator'
import { useLocation } from 'react-router-dom'
import useOnlineStatus from '../../hooks/useOnlineStatus'
import { getBrandingUrls } from '../../config/market'
import { warmupLogoCache } from '../../offline/logo-cache-warmup'
import { NAV_LAYOUT_MARGIN_START } from '../../consts/nav-layout-margin'
import LayoutModeSwitch from '../layout-mode-switch'
import { NotificationBellButton } from '../notifications/notification-bell-button'

const BRAND = getBrandingUrls()

const TOOLBAR_HEIGHT_PX = 64

const DesktopToolbar = ({ fromHelp = null }) => {
  const { control } = useForm()
  const location = useLocation()
  const isOnline = useOnlineStatus()

  useEffect(() => {
    if (!isOnline) return
    warmupLogoCache().catch(() => {})
  }, [isOnline])

  const { mode, toggleTheme } = useContext(ThemeContext)
  const theme = useTheme()

  return (
    <Toolbar
      disableGutters
      sx={{
        backgroundColor: theme.palette.newColors.gray,
        height: TOOLBAR_HEIGHT_PX,
        minHeight: TOOLBAR_HEIGHT_PX,
        maxHeight: TOOLBAR_HEIGHT_PX,
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        overflow: 'hidden',
        flexWrap: 'nowrap',
        alignItems: 'center',
        px: 2
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flex: '1 1 auto',
          minWidth: 0,
          overflow: 'hidden',
          marginInlineStart: fromHelp ? 0 : NAV_LAYOUT_MARGIN_START
        }}
      >
        <Box
          component="img"
          src={BRAND.toolbarWhite}
          alt="ADaMS logo"
          sx={{
            width: 140,
            height: 40,
            flexShrink: 0,
            display: 'block',
            objectFit: 'contain'
          }}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-end',
          flex: '0 0 auto',
          flexShrink: 0,
          gap: 2,
          ml: 'auto'
        }}
      >
        <OnlineStatusIndicator />
        <NotificationBellButton isDisabled={!isOnline} />
        <LayoutModeSwitch inverted />
        <Controller
          name="theme"
          control={control}
          render={({ field, field: { onChange } }) => (
            <FormControlLabel
              sx={{ m: 0, flexShrink: 0 }}
              control={
                <MaterialUISwitch
                  checked={mode === 'dark'}
                  onClick={(e) => {
                    onChange(e.target.checked)
                    toggleTheme(e.target.checked ? 'dark' : 'light')
                  }}
                  {...field}
                />
              }
            />
          )}
        />
        <UserControls
          state={location.state}
          noElev={true}
          disableProfile={!isOnline}
        />
      </Box>
    </Toolbar>
  )
}

export default DesktopToolbar
